import {FeatureFlagStore} from "@/store/types/FeatureFlagStore";

const featureFlags = new FeatureFlagStore();

export {featureFlags};
